<mat-card class="fav-card">
  <mat-card-header>
    <mat-card-title>Favorites</mat-card-title>
    <mat-card-subtitle
      >Select your favorite aircrafts and instructors</mat-card-subtitle
    >
  </mat-card-header>

  <mat-card-content class="fav-card-content">
    <div *ngIf="loading" class="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="28"
      ></mat-progress-spinner>
      <span>Loading...</span>
    </div>

    <ng-container *ngIf="!loading">
      <div *ngIf="errorMsg" class="error-msg">{{ errorMsg }}</div>

      <section class="group">
        <h3 class="title">
          <mat-icon fontSet="material-symbols-outlined" inline>flight</mat-icon>
          <span>Aircrafts</span>
        </h3>
        <div class="checkbox-grid">
          <mat-checkbox
            *ngFor="let ac of aircrafts"
            [checked]="selectedAircrafts.has(ac.id)"
            (change)="toggleAircraft(ac.id)"
            class="pill"
          >
            {{ ac.code }} <small>({{ ac.model }})</small>
          </mat-checkbox>
        </div>
      </section>

      <section class="group">
        <h3 class="title">
          <mat-icon fontSet="material-symbols-outlined" inline
            >person_apron</mat-icon
          >
          <span>Instructors</span>
        </h3>
        <div class="checkbox-grid">
          <mat-checkbox
            *ngFor="let ins of instructors"
            [checked]="selectedInstructors.has(ins.id)"
            (change)="toggleInstructor(ins.id)"
            [disabled]="selfOnlyInstructor && ins.id !== myInstructorId"
            class="pill"
          >
            {{ ins.name }}
          </mat-checkbox>
        </div>

        <!-- <div *ngIf="isInstructor" class="self-only">
          <mat-checkbox
            [(ngModel)]="selfOnlyInstructor"
            (change)="onToggleSelfOnly()"
          >
            N’afficher que ma propre ligne instructeur
          </mat-checkbox>
        </div> -->
      </section>
    </ng-container>
  </mat-card-content>

  <mat-card-actions align="end">
    <button
      mat-flat-button
      color="primary"
      (click)="save()"
      [disabled]="saving"
    >
      <mat-icon fontSet="material-symbols-outlined">save</mat-icon> Save
    </button>
    <button mat-stroked-button (click)="cancel()">
      <mat-icon fontSet="material-symbols-outlined">close</mat-icon> Cancel
    </button>
  </mat-card-actions>
</mat-card>
